var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlarm(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4999 8.00006H10.9999V14.0001L15.7499 16.8501L16.4999 15.6201L12.4999 13.2501V8.00006ZM17.3369 1.81006L21.9439 5.65506L20.6639 7.19006L16.0539 3.34706L17.3369 1.81006ZM6.66288 1.81006L7.94489 3.34606L3.33688 7.19006L2.05688 5.65406L6.66288 1.81006ZM11.9999 4.00006C7.02988 4.00006 2.99988 8.03006 2.99988 13.0001C2.99988 17.9701 7.02988 22.0001 11.9999 22.0001C16.9699 22.0001 20.9999 17.9701 20.9999 13.0001C20.9999 8.03006 16.9699 4.00006 11.9999 4.00006ZM11.9999 20.0001C8.13988 20.0001 4.99988 16.8601 4.99988 13.0001C4.99988 9.14006 8.13988 6.00006 11.9999 6.00006C15.8599 6.00006 18.9999 9.14006 18.9999 13.0001C18.9999 16.8601 15.8599 20.0001 11.9999 20.0001Z",
    fill: "#007bff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlarm);
export default __webpack_public_path__ + "static/media/alarm.e12148694d11872f08505b5adff571b1.svg";
export { ForwardRef as ReactComponent };